import { PageBreadcrumb } from "@/components/page-breadcrumb";
import { RcList } from "./rc-list";

// Cross-app RC config manager (the internalized Feishu "RC配置管理" bitable).
const Rcs = () => (
  <div className="flex flex-col gap-4">
    <PageBreadcrumb current="RC Configs" />
    <RcList />
  </div>
);

export default Rcs;
